class StickyScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!window.BAO.MediaBreakpoints.isMd) return

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.currentTop = 0

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    if (!window.BAO.MediaBreakpoints.isMd) return

    this.onScroll = this.onScroll.bind(this)
    this.listeners.add(window, 'scroll', this.onScroll)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PRODUCT.OPTION_CHANGED,
      this.onScroll,
    )
  }

  onScroll () {
    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)
    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false
    this.setSticky()
  }

  setSticky () {
    if (!this.els?.content?.exists) return

    const contentEl = this.els.content.element
    const contentHeight = contentEl.offsetHeight
    const viewportHeight = window.innerHeight
    const headerHeight = this.getHeaderHeight()

    if (contentHeight <= viewportHeight - headerHeight) {
      this.classList.add('prd-Detail_Columns-defaultSticky')
      contentEl.style.removeProperty('inset-block-start')
      this.lastKnownY = window.scrollY
      return
    }

    this.classList.remove('prd-Detail_Columns-defaultSticky')

    const currentY = window.scrollY
    const delta = currentY - this.lastKnownY
    this.lastKnownY = currentY

    this.currentTop -= delta

    const announcementHeight = this.getAnnouncementHeight()
    const maxTop = headerHeight
    const minTop = viewportHeight - contentHeight - announcementHeight

    this.currentTop = Math.min(maxTop, Math.max(minTop, this.currentTop))

    contentEl.style.setProperty(
      'inset-block-start',
      `${Math.round(this.currentTop)}px`,
    )
  }

  getHeaderHeight () {
    const header = document.querySelector('.hd-Banner')
    if (!header) return 0
    return Math.max(0, header.getBoundingClientRect().bottom)
  }

  getAnnouncementHeight () {
    return (
      parseInt(
        getComputedStyle(document.body)
          .getPropertyValue('--Announcement_Height_Bottom')
          .trim(),
        10,
      ) || 0
    )
  }
}

if (!customElements.get('sticky-scroll')) {
  customElements.define('sticky-scroll', StickyScroll)
}
